/* eslint-disable no-shadow */
/* eslint-disable valid-jsdoc */
/**
 * Return the list of all tabs
 * @param {State} state vuex state
 */
export const tabs = ({ tabs }) => tabs

/**
 * Return true if dialog is open
 * @param {State} state vuex state
 */
export const dialogOpened = ({ dialogOpen }) => dialogOpen

export const createTabDialogOpened = ({ createTabDialogOpened }) => createTabDialogOpened
